/*eslint-disable*/
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import trainer from './trainer'
import olympiad from './olympiad/index'
import battle from './battle/index';
import games from './games'
import lists from './lists'
import * as actions from './actions'
import * as types from "./mutation-types";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      isShowSidebar: false,
    },
    actions,
    modules: {
        auth,
        trainer,
        games,
        olympiad,
        battle,
        lists,
        router: {
            state: {
                previousRoute: null
            },
            mutations: {
              [types.SET_PREVIOUS_ROUTE](state, previousRoute) {
                state.previousRoute = previousRoute;
              },
            }
        }
    }
});
